import { FormElement } from '../../../components/FormElement';

export const Users = () => {
    return <FormElement headingText="Użytkownicy">
        Tutaj będą użytkownicy
    </FormElement>
}
